"use strict";

exports.__esModule = true;
exports.getDefaultFilters = getDefaultFilters;
exports.getDefaultPageSize = getDefaultPageSize;
exports.getDefaultSortOrder = getDefaultSortOrder;
exports.nearestIndexInPageSizeList = nearestIndexInPageSizeList;
exports.renderNotIdealState = renderNotIdealState;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _DataTable = require("../../Core/DataTable");
var _unformatter = require("./Formatters/unformatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function renderNotIdealState(style, hasError) {
  if (hasError === void 0) {
    hasError = false;
  }
  return /*#__PURE__*/_react["default"].createElement(_core.NonIdealState, {
    style: style,
    title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: hasError ? "DataTableElement.errorFetching" : "DataTableElement.noData",
      defaultMessage: hasError ? "Error Loading Data" : "No data"
    })
  });
}
function getDefaultSortOrder(columns) {
  return columns.reduce(function (acc, col) {
    if (col.enableSorting && (col.defaultSortOrder === "ASC" || col.defaultSortOrder === "DESC")) {
      var id = col.id;
      var desc = col.defaultSortOrder.toLowerCase() === "desc";
      acc.push({
        id: id,
        desc: desc,
        property: id,
        direction: col.defaultSortOrder.toLowerCase()
      });
    }
    return acc;
  }, []);
}
function getDefaultFilters(columns, contexts) {
  return columns.reduce(function (acc, col) {
    if (!!col.canFilter && !!col.defaultFilterValue) {
      var id = col.id;
      var unformattedValue = (0, _unformatter.unformatter)(col.type, col.defaultFilterValue, contexts);
      if (col.exactMatch === false) {
        acc.push({
          id: id,
          value: unformattedValue
        });
        return acc;
      }

      /* Some cells in React-table are rendrered as numbers and some as strings */
      acc.push({
        id: id,
        value: !!parseInt(unformattedValue) ? [unformattedValue, parseInt(unformattedValue)] : [unformattedValue]
      });
    }
    return acc;
  }, []);
}
function nearestIndexInPageSizeList(pageSizes, defaultValue) {
  var sizes = pageSizes.map(function (size) {
    return Math.abs(defaultValue - size);
  });
  var leastIndexPair = [0, Infinity];
  sizes.forEach(function (size, idx) {
    if (size < leastIndexPair[1]) {
      leastIndexPair = [idx, size];
    }
  });
  return pageSizes[leastIndexPair[0]];
}
function getDefaultPageSize(configuration, height) {
  return configuration && typeof configuration.defaultPageSize === "number" ? configuration.defaultPageSize : (0, _DataTable.calculateRowsForHeight)(height);
}